import React from 'react';
import { motion } from 'framer-motion';
import {
  Wallet,
  ChevronRight,
  Bitcoin,
  Shield,
  TrendingUp
} from 'lucide-react';

export function DigitalWallet() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white p-6 md:p-8 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-xl mx-auto text-center bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100"
      >
        <div className="flex flex-col items-center justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-orange-100 flex items-center justify-center mb-4">
            <Wallet size={40} className="text-orange-600" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Digital Wallet Coming Soon!</h1>
          <p className="text-lg md:text-xl text-gray-600">
            We're building a comprehensive cryptocurrency wallet and trading platform to help you manage your digital assets securely.
          </p>
        </div>
        <p className="text-gray-500 mb-6">
          Stay tuned for features like secure wallet management, real-time trading, portfolio tracking, and advanced security features.
        </p>
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => window.history.back()}
          className="bg-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:bg-orange-700 transition-colors flex items-center justify-center gap-2 mx-auto"
        >
          Go Back <ChevronRight size={20} />
        </motion.button>
      </motion.div>
    </div>
  );
}